import Http from './base';
import {
  BASE_URL,
  LISTING_DATA,
  MY_LISTINGS,
  NPS_FORM,
  PRICINGS_URL,
  VENDER_BASE_URL
} from './base/constants';

class ListingsService {
  get({ page = 1 }) {
    return Http.get(`${BASE_URL}${MY_LISTINGS}`, {
      params: { page: page - 1 }
    });
  }

  put(data) {
    return Http.put(`${BASE_URL}${MY_LISTINGS}/${data.id}`, data, {
      headers: { ContentType: 'application/json' }
    });
  }

  delete({ id, status }) {
    return Http.delete(`${BASE_URL}${MY_LISTINGS}/${id}/status/${status}`);
  }

  getById(id) {
    return Http.get(`${BASE_URL}${MY_LISTINGS}/${id}`);
  }

  getPaymentURL(id) {
    return Http.get(`${BASE_URL}${MY_LISTINGS}/${id}/urlpagamento`);
  }

  getListingStats(id) {
    return Http.get(`${BASE_URL}${MY_LISTINGS}/${id}/estatistica`);
  }

  getListingEvaluation(id) {
    return Http.get(`${BASE_URL}${MY_LISTINGS}/${id}/qualidade`);
  }

  getListingPlan(id) {
    return Http.get(`${BASE_URL}${MY_LISTINGS}/${id}/plano`);
  }

  republish(id) {
    return Http.put(`${BASE_URL}${MY_LISTINGS}/${id}/renovar`);
  }

  saveImage(id, data) {
    return Http.post(`${BASE_URL}${MY_LISTINGS}/${id}/imagem`, data);
  }

  getPriceSuggestions({ state, version, yearModel, mileage }) {
    return Http.get(
      `${BASE_URL}${LISTING_DATA}/precos/${state}/${version}/${yearModel}/${mileage}`
    );
  }

  getFipeFeatureFlag() {
    return Http.get(
      `${VENDER_BASE_URL}/pf/api/v1/jornada/config/section/precoVeiculo/key/tabelaFipe`
    );
  }

  getPhotosFeatureFlag() {
    return Http.get(`${VENDER_BASE_URL}/pf/api/v1/jornada/config/section/anuncio/key/minimoFotos`);
  }

  getExtras() {
    return Http.get(`${BASE_URL}${LISTING_DATA}/opcionais`);
  }

  getDescriptionItems() {
    return Http.get(`${BASE_URL}${LISTING_DATA}/itensdescricao`);
  }

  getColors() {
    return Http.get(`${BASE_URL}${LISTING_DATA}/cores`);
  }

  getFuelTypes() {
    return Http.get(`${BASE_URL}${LISTING_DATA}/combustiveis`);
  }

  getModelYears({ modelId }) {
    return Http.get(`${BASE_URL}${LISTING_DATA}/anosmodelo/${modelId}`);
  }

  getModelManufacturingYears(yearModel) {
    return Http.get(`${BASE_URL}${LISTING_DATA}/anosfabricacao/${yearModel}`);
  }

  getDeletingStatus(status) {
    return Http.get(`${BASE_URL}${LISTING_DATA}/statusexclusao/${status}`);
  }

  getListingVersions({ modelId, yearModel }) {
    return Http.get(`${BASE_URL}${LISTING_DATA}/versoes/${modelId}/${yearModel}`);
  }

  getPricings({ state, version, yearModel, mileage }) {
    return Http.get(`${PRICINGS_URL}${state}/${version}/${yearModel}/${mileage}`);
  }

  setNPS(data) {
    return Http.post(`${BASE_URL}${NPS_FORM}`, data);
  }

  updateNPS(data) {
    return Http.put(`${BASE_URL}${NPS_FORM}`, data);
  }
}

export default new ListingsService();
